import { EnglishArabicDTO } from "bnsights-control-library"
export class SMSTemplateInfoDTO
{
      ID:number
      SMS :EnglishArabicDTO=new EnglishArabicDTO();
      SmsEN :string
      SmsAR :string
      LanguageModeItemID:number
      LanguageModeItemName:string

}
     